import { memo } from 'react';

/*
    ____,-------------------------------,____
    \   |             Icons             |   /
    /___|-------------------------------|___\
*/

export const ResetIcon = memo(function ResetIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill="#fff"
        d="m8 3.191-.72.008 1.783-1.843A.807.807 0 0 0 9.29.79a.807.807 0 0 0-.227-.565.775.775 0 0 0-1.094 0L6.194 2.06a2.766 2.766 0 0 0-.775 1.931c0 .729.276 1.417.775 1.932l1.775 1.835a.775.775 0 0 0 1.094 0 .807.807 0 0 0 .227-.565.807.807 0 0 0-.227-.566L7.298 4.802l.643-.008H8c3.559 0 6.452 2.153 6.452 4.802 0 2.65-2.893 4.802-6.452 4.802s-6.452-2.153-6.452-4.802c0-.941.375-1.856 1.084-2.646a.817.817 0 0 0-.041-1.131.76.76 0 0 0-1.094.043C.519 6.952 0 8.244 0 9.596 0 13.126 3.59 16 8 16s8-2.873 8-6.403c0-3.53-3.59-6.402-8-6.402V3.19Z"
      />
    </svg>
  );
});

export const BucketIcon = memo(function BucketIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill="#fff"
        d="m14.264 12.776.97-9.342a.845.845 0 0 0-.013-.225C15.051 1.307 12.083 0 8.001 0 3.918-.001.95 1.309.783 3.183a.941.941 0 0 0-.018.25l.97 9.342a2.736 2.736 0 0 0 1.159 1.985c1.254.857 2.829 1.239 5.105 1.239 2.276 0 3.85-.382 5.104-1.24a2.712 2.712 0 0 0 1.159-1.984h.002ZM2.324 3.353c0-.63 1.95-1.806 5.677-1.806 3.726 0 5.677 1.176 5.677 1.806 0 .63-1.95 1.807-5.677 1.807-3.727 0-5.678-1.177-5.678-1.807Zm9.908 10.13c-.66.45-1.739.967-4.231.967-2.493 0-3.572-.52-4.232-.968a1.183 1.183 0 0 1-.493-.865L2.553 5.66l.405.178c1.31.57 3.056.872 5.043.872 1.986 0 3.732-.302 5.042-.872l.405-.175-.723 6.957c-.038.361-.216.677-.492.865v-.003Z"
      />
    </svg>
  );
});
